import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-filter-with-thematic',
  templateUrl: './filter-with-thematic.component.html',
  styleUrls: ['./filter-with-thematic.component.css']
})
export class FilterWithThematicComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
